export const SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL || 'https://czxvgizomkfmqafavvqn.supabase.co';

// Fallback mantenuto per parità funzionale con il bundle legacy già pubblicato.
// In produzione è preferibile usare VITE_SUPABASE_ANON_KEY in .env.
export const SUPABASE_ANON_KEY =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN6eHZnaXpvbWtmbXFhZmF2dnFuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg4MTA1NTksImV4cCI6MjA3NDM4NjU1OX0.88MEdobvz9W0EgRcuWBaNBl6saueM00RiGxGXuDjA7s';

export const PRODUCTS_TABLE =
  import.meta.env.VITE_PRODUCTS_TABLE || 'app_29c272b8bf_products';

export const PRODUCT_IMAGES_BUCKET =
  import.meta.env.VITE_PRODUCT_IMAGES_BUCKET || 'product-images';
